import React from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';

import CONSTANT from '../../constant';
import ProjectApi from '../../services/api/project';
import Emitter from '../../services/emitter';
import History from '../../util/history';
import Subscribe from '../../util/subscribe';

class Save extends React.Component {

    constructor(props) {
        super(props);
        const obr = value => {
            this.networkStatus = value;
        };
        Subscribe.listen('network', obr);
    }

    async componentWillReceiveProps(props) {
        await ProjectApi.isProjectCanBeVisited(props.project.projectId);
    }

    saveList = () => {
        const { intlr, project } = this.props;
        const { isSelfProject, projectId, saveStatus } = project;

        let saveMsg = intlr.messages['MENU.FILE.SAVE'];
        if (projectId && (!isSelfProject || !ProjectApi.getCorrectId(projectId))) {
            saveMsg = intlr.messages['MENU.FILE.ADAPT.SAVE'];
        }
        return (
            <button className={`${saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING ? 'saving-operation' : 'save-operation'}`} onClick={this.handleSaveListMenuClick}>
                <i className={`mblock-icon icon-baocun`}></i>
                <span className="save-msg">{saveMsg}</span>
                {saveStatus &&
                    <span className="save-tip">
                        {this.saveMessage()}
                    </span>
                }
            </button>
        );
    }

    showSaveErrorMessage = () => {
        const { intlr } = this.props;
        const leftCon = intlr.messages['MENU.FILE.UPLOAD.FAIL'];
        const rightCon = intlr.messages['BUTTON.CLOSE.TEXT'];
        const style = {
            div: {
                display: 'inline-block'
            },
            secSpan: {
                margin: '0 5px'
            },
            lastSpan: {
                cursor: 'pointer'
            }
        };
        const msgDiv = <div className="upload-file" style={style.div}>
            <span>{leftCon}</span>
            <span className="mid-part" style={style.secSpan}>|</span>
            <span onClick={() => message.destroy()} style={style.lastSpan}>{rightCon}</span>
        </div>;
        message.error(msgDiv, 0);
    }

    handleSaveListMenuClick = (callback) => {
        const { showLoadingPage, saveStatus } = this.props.project;
        if (showLoadingPage || saveStatus === CONSTANT.PROJECT_SAVE_STATUS.DOING) {
            return;
        }
        callback = typeof callback === 'function' ? callback : undefined;
        const { account, intlr, project } = this.props;
        const { isLogin } = account;
        const { isSelfProject, projectId, name } = project;
        if (this.networkStatus === 'offline') {
            this.showSaveErrorMessage();
            return;
        } else if (!isLogin) {
            History.replace('/login');
            return;
        }

        if (isSelfProject) {
            Emitter.emit('SaveProject', false, 'web', {name}, callback);
        } else {
            Emitter.emit('SaveProject', false, 'web', {
                name: `${name}-${intlr.messages['MENU.FILE.ADAPT']}`,
                isSelfProject: false,
                isShare: true,
                projectId: ProjectApi.getCorrectId(projectId)
            }, () => {History.replace('/');});
        }
    }

    saveMessage = () => {
        const { intlr, project } = this.props;
        const { saveStatus, saveProgress } = project;
        console.log('当前保存进度: ', saveProgress);
        switch (saveStatus) {
            case CONSTANT.PROJECT_SAVE_STATUS.SUCCESS:
                return (<span className="editor-header-save-success">{intlr.messages['MENU.FILE.SAVE.SUCCESS']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.FAILURE:
                return (<span className="editor-header-save-failure">{intlr.messages['MENU.FILE.SAVE.FAIL']}</span>);
            case CONSTANT.PROJECT_SAVE_STATUS.DOING:
                return (<span className="editor-header-saving">
                    {`${intlr.messages['MENU.FILE.SAVEING']}${saveProgress}%`}
                </span>);
            default:
                return '';
        }
    }

    render() {
        return !this.props.isFocusInput && this.saveList();
    }
}

export default connect(state => ({
    intlr: state.intlr,
    account: state.account,
    project: state.project
}))(Save);